import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const NAV_COLS = {
  Studio: [
    { label: 'Home',     href: '/',        external: false },
    { label: 'Services', href: '/services', external: false },
    { label: 'Projects', href: '/projects', external: false },
    { label: 'Hosting',  href: '/hosting',   external: false },
    { label: 'About',    href: '/about',   external: false },
    { label: 'Contact',  href: '/contact', external: false },
  ],
  // Crawlable links to every service page from every page on the site.
  Websites: [
    { label: 'Web design Brisbane',  href: '/web-design-brisbane', external: false },
    { label: 'Business websites',    href: '/websites/business',   external: false },
    { label: 'One-page websites',    href: '/websites/one-page',   external: false },
    { label: 'Online stores',        href: '/websites/ecommerce',  external: false },
    { label: 'Web apps & portals',   href: '/websites/web-app',    external: false },
    { label: 'Start a project',      href: '/start-a-project',     external: false },
  ],
  Legal: [
    { label: 'Privacy Policy',   href: '/privacy', external: false },
    { label: 'Terms of Service', href: '/terms',   external: false },
    { label: 'Refund Policy',    href: '/refund',  external: false },
  ],
  'Sister Sites': [
    { label: 'CJM Portal', href: 'https://portal.cjmstudios.com', external: true },
  ],
}

function DiscordIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028 14.09 14.09 0 001.226-1.994.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z"/>
    </svg>
  )
}
function TikTokIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.27 8.27 0 004.83 1.56V6.82a4.85 4.85 0 01-1.06-.13z"/>
    </svg>
  )
}

const SOCIALS = [
  { Icon: DiscordIcon, label: 'Discord', href: 'https://discord.gg/mtNfz3xgmG' },
  { Icon: TikTokIcon,  label: 'TikTok',  href: 'https://www.tiktok.com/@cjm_studios' },
]

export default function Footer() {
  return (
    <footer style={{ position: 'relative', background: '#000', overflow: 'hidden' }}>
      {/* Top glow line */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 1, background: 'linear-gradient(90deg,transparent,rgba(6,182,212,0.28),rgba(139,92,246,0.18),transparent)' }} />

      {/* Ambient bottom glow */}
      <div className="bg-orb" style={{ width: 700, height: 280, background: 'rgba(6,182,212,0.04)', bottom: 0, left: '50%', transform: 'translateX(-50%)', filter: 'blur(90px)' }} />

      {/* Giant watermark — purely decorative, hidden from a11y tree so it's exempt
          from the text-contrast audit and can stay at its intended subtle opacity */}
      <div aria-hidden="true" style={{
        position: 'absolute', bottom: '-4%', left: '50%', transform: 'translateX(-50%)',
        fontFamily: 'Geist Variable, sans-serif',
        fontSize: 'clamp(36px, 6vw, 80px)',
        fontWeight: 800, color: 'rgba(255,255,255,0.02)',
        lineHeight: 1, pointerEvents: 'none', userSelect: 'none', letterSpacing: '-0.05em',
        whiteSpace: 'nowrap',
      }}>
        CJM Studios
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '80px 32px 40px', position: 'relative', zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr 1fr', gap: 36, marginBottom: 64 }}
          className="footer-grid"
        >
          {/* Brand */}
          <div>
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none', marginBottom: 20 }}>
              <div>
                <span style={{ color: '#fff', fontWeight: 600, fontSize: 15, fontFamily: 'Geist Variable, sans-serif', letterSpacing: '-0.02em', display: 'block' }}>
                  CJM <span style={{ color: '#22d3ee' }}>Studios</span>
                </span>
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Create · Innovate · Elevate</span>
              </div>
            </Link>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, lineHeight: 1.85, maxWidth: 230, marginBottom: 28 }}>
              A Brisbane-based web design and development studio — websites, web apps, and Stripe setups, plus custom software built from scratch and proven in production.
            </p>
            <div style={{ display: 'flex', gap: 8 }}>
              {SOCIALS.map(({ Icon, label, href }) => (
                <a
                  key={label} href={href} aria-label={label}
                  target="_blank" rel="noreferrer"
                  style={{
                    width: 36, height: 36, borderRadius: 9,
                    border: '1px solid rgba(255,255,255,0.06)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'rgba(255,255,255,0.5)',
                    transition: 'color 0.25s, border-color 0.25s, background 0.25s, box-shadow 0.25s',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color        = '#22d3ee'
                    e.currentTarget.style.borderColor  = 'rgba(6,182,212,0.3)'
                    e.currentTarget.style.background   = 'rgba(6,182,212,0.07)'
                    e.currentTarget.style.boxShadow    = '0 0 16px rgba(6,182,212,0.15)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color        = 'rgba(255,255,255,0.5)'
                    e.currentTarget.style.borderColor  = 'rgba(255,255,255,0.06)'
                    e.currentTarget.style.background   = 'transparent'
                    e.currentTarget.style.boxShadow    = 'none'
                  }}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          {Object.entries(NAV_COLS).map(([title, links]) => (
            <div key={title}>
              <h3 style={{ color: 'rgba(255,255,255,0.5)', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.2em', marginBottom: 20 }}>
                {title}
              </h3>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 14 }}>
                {links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, textDecoration: 'none', transition: 'color 0.2s' }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.7)' }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)' }}
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, textDecoration: 'none', transition: 'color 0.2s' }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.7)' }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)' }}
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </motion.div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: 28,
          borderTop: '1px solid rgba(255,255,255,0.04)',
          display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 12,
        }}>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>
            © {new Date().getFullYear()} CJM Studios. All rights reserved.
          </p>
        </div>
      </div>

      <style>{`
        @media(max-width:960px) {
          .footer-grid { grid-template-columns: 1fr 1fr 1fr !important; }
          .footer-grid > div:first-child { grid-column: 1 / -1; }
        }
        @media(max-width:768px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media(max-width:480px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  )
}
